import React from 'react';
import { motion } from 'framer-motion';
import { Zap, CheckCircle2, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

function Success() {
  return (
    <div className="min-h-screen bg-black">
      <header className="fixed w-full bg-black/80 backdrop-blur-md z-50">
        <nav className="container mx-auto px-6 py-4">
          <Link to="/" className="flex items-center space-x-2">
            <Zap className="h-8 w-8 text-blue-500" />
            <span className="text-xl font-bold text-white">Zimerson</span>
          </Link>
        </nav>
      </header>

      <div className="container mx-auto px-6 pt-32 pb-20">
        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.8 }}
          className="max-w-3xl mx-auto text-center"
        >
          <motion.div
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            transition={{ delay: 0.2, type: "spring", stiffness: 260, damping: 20 }}
            className="mb-8"
          >
            <CheckCircle2 className="h-24 w-24 text-green-500 mx-auto" />
          </motion.div>
          <h1 className="text-4xl font-bold text-white mb-6">Success!</h1>
          <p className="text-xl text-gray-300 mb-12">
            Thank you for your submission. We'll be in touch shortly!
          </p>
          <Link
            to="/"
            className="inline-flex items-center space-x-2 bg-gradient-to-r from-blue-600 to-blue-500 text-white px-8 py-4 rounded-lg text-lg font-semibold hover:from-blue-700 hover:to-blue-600 transition-colors"
          >
            <span>Return Home</span>
            <ArrowRight className="h-6 w-6" />
          </Link>
        </motion.div>
      </div>
    </div>
  );
}

export default Success;